import React, { useState, useEffect } from 'react';
import ReactTable from 'react-table-v6';

import { AddCircle, RemoveCircle, ModeEdit } from '@mui/icons-material';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import { useConfirm } from 'material-ui-confirm';
import 'react-table-v6/react-table.css';

import CommunicationInterfaceModal from '../CommunicationInterfaceModal';

const CommunicationInterfacesList = (props) => {
    let [openModal, setOpenModal] = useState(false);
    const [interfaces, setInterfaces] = useState();
    const [selectedInterface, setSelectedInterface] = useState();

    const confirm = useConfirm();

    useEffect(() => {
        setInterfaces(props.interfaces)
    }, [props.interfaces])

    const deleteInterface = (i) => {
                confirm({
                        title: "Delete this interface?",
                        description: 'This action deletes this interface.'
                })
                .then(() => {
                        props.deleteInterfaceCallback(i)
                })
                .catch(() => {console.log("User cancelled action") });
        }

    const width =
        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    const columns = [
        {
            Header: 'Name',
            accessor: 'name',
            style: { paddingTop: 15 },
            Cell: (p) => {
                return p.value;
            },  
        },
        {
            Header: 'Address',
            accessor: 'address',
            style: { paddingTop: 15 },
        },
        {
            Header: 'Connectivity',
            accessor: 'physical_connectivity',
            style: { paddingTop: 15 },
            show: width > 1000,
        },
        {
            Header: 'Protocol',
            accessor: 'protocol',
            style: { paddingTop: 15 },
        },
        { 
            Header: '',
            accessor: 'interface_id',
            Cell: i => {
                return <div>
                    <Tooltip title="Edit interface">
                        <IconButton
                            variant="contained"
                            color="primary"
                            aria-label={"Edit interface" }
                            size={"small"}
                            onClick={() => {
                                setSelectedInterface(i.original)
                                setOpenModal(true)
                             }}>
                            <ModeEdit />
                         </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete interface">
                        <IconButton
                            variant="contained"
                            color="primary"
                            aria-label={"Delete interface" }
                            size={"small"}
                            onClick={() => {
                                deleteInterface(i.original)
                          }}
                          >
                        <RemoveCircle style={{color: "#FF4438"}} />
                        </IconButton>
                    </Tooltip>
                    </div>
            },
            width: 100,
            show: props.deleteInterfaceCallback != null
        },  
    ];

    return (
        <div className="space-list">
            <CommunicationInterfaceModal
                open={openModal}
                siteId={props.id}
                selectedInterface={selectedInterface}
                addOrUpdateInterfaceCallback={props.addOrUpdateInterfaceCallback}
                getAllProtocols={props.getAllProtocols} 
                getAllPhysicalConnectionTypes={props.getAllPhysicalConnectionTypes}
                closeCallback={() => {
                    setOpenModal(false);
                }}
            />
            <div className="space-add-mode">
                {interfaces && interfaces.length ? (
                    <Tooltip title="Add Communication Interface">
                        <IconButton
                            variant="contained"
                            color="primary"
                            aria-label={'Add Communication Interface'}
                            onClick={() => {
                                setSelectedInterface(null)
                                setOpenModal(true);
                            }}
                        >
                            <AddCircle
                                style={{
                                    fill: '#00b088',
                                    background: 'white',
                                    transform: 'scale(1.0)',
                                }}
                            />
                        </IconButton>
                    </Tooltip>
                ) : null}
            </div>
            <div className="section-header">Communication Interfaces </div>
            {interfaces && interfaces.length ? (
                <div className="point-list-table">
                    <ReactTable
                        key={(interfaces && interfaces.length) || 0}
                        data={interfaces || []}
                        columns={columns}
                        minRows={0}
                        defaultPageSize={10}
                        showPagination={interfaces && interfaces.length > 10}
                    />
                </div>
            ) : (
                <div className="bulk_add_prompt">
                    <IconButton
                        variant="contained"
                        color="primary"
                        aria-label={'Add Communication Interface'}
                        onClick={() => {
                            setOpenModal(true);
                        }}
                    >
                        <AddCircle style={{ fill: '#00b088', background: 'white' }} />
                    </IconButton>
                    There are currently no communication interfaces configured. Add some now!
                </div>
            )}
        </div>
    );
};

export default CommunicationInterfacesList;
